const translations = {
    deleteButton: 'Delete Selected',
    filterButton: 'Filter'
};

export default translations;
